'use strict';

module.exports = require('./Autowhatever').default;


// WEBPACK FOOTER //
// ../~/react-autowhatever/dist/index.js